function isIPad() {
  const ua = window.navigator.userAgent;
  if (ua.indexOf('iPad') > -1) {
    return true;
  }

  if (ua.indexOf('Macintosh') > -1) {
    try {
      document.createEvent('TouchEvent');
      return true;
    } catch {
      // eslint-disable-next-line no-empty
    }
  }

  return false;
}

function isM1Mac() {
  const w = document.createElement('canvas').getContext('webgl');
  const d = w.getExtension('WEBGL_debug_renderer_info');
  const g = d && (w.getParameter(d.UNMASKED_RENDERER_WEBGL) || '');
  if (g.match(/Apple/) && !g.match(/Apple GPU/)) {
    return true;
  }
  if (w.getSupportedExtensions().indexOf('WEBGL_compressed_texture_s3tc_srgb') === -1) {
    return true;
  }
  return false;
}

function isIDevice() {
  return isIPad() || /(iPhone|iPod)/i.test(window.navigator.userAgent);
}

function isAppleTV() {
  return /AppleTV/i.test(window.navigator.userAgent);
}

function isItselfLinkable() {
  if (isIDevice()) {
    return true;
  }
  return false;
}

export {
  isIPad, isM1Mac, isIDevice, isAppleTV,
};
export default isItselfLinkable;
